/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from '@mui/icons-material/Download';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";

function FileCard({ color, thumbnail, filename, filekey }) {
    return (
        <Card sx={{ height: '100px' }}> {/* Fixed height for the card */}
            <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
                <MDBox
                    color={color === "light" ? "dark" : "white"}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="4rem"
                    height="4rem"
                    mt={-3}
                >
                    <MDAvatar size="xl" src={thumbnail} alt="word" variant="rounded" />
                </MDBox>
                <MDBox
                    textAlign="right"
                    lineHeight={1.25}
                    width="calc(100% - 5rem)" // Fixed width accounting for the avatar
                >
                    <MDTypography
                        variant="button"
                        fontWeight="light"
                        color="text"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'block'
                        }}
                    >
                        {filename}
                    </MDTypography>
                    <MDBox mt={1}>    
                        <Tooltip
                            title="Download File"
                        >
                            <IconButton>
                                <DownloadIcon />
                            </IconButton>
                        </Tooltip>
                    </MDBox>
                </MDBox>
            </MDBox>
        </Card>
    );
}

// Setting default values for the props of FileCard
FileCard.defaultProps = {
    color: "info",
    percentage: {
        color: "success",
        text: "",
        label: "",
    },
};

// Typechecking props for the FileCard
FileCard.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    title: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    percentage: PropTypes.shape({
        color: PropTypes.oneOf([
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "error",
            "dark",
            "white",
        ]),
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    }),
    icon: PropTypes.node.isRequired,
};

export default FileCard;
